<template>
    <div class="answer-list-evaluation-btn">

        <!-- ----------------------------------------- -->
        <!-- "EVALUATE" button -->
        <!-- ----------------------------------------- -->

        <div class="evaluation-btn-container" v-if="mustShowUrgentPopup === false">
            <div class="btn-eval" v-if="getCurrentAssessmentStatus === getAssessmentStatuses.EVALUATED && ((isKSB !== 'PF_CHATBOT_STUDY' && isKSB !== 'PF_CHATBOT_PUBLIC') || (isKSB === 'PF_CHATBOT_PUBLIC' && mustShowUrgentPopup === false))">
                <v-btn @click.stop="goToChatbotEvaluationPage()" id="btnGoToAssessmentEvaluation" block color="primary" class="btn color-on-primary-text">{{ text('api.chatbot.btn.evaluate')}}</v-btn>
            </div>
            <div class="btn-eval" v-if="getCurrentAssessmentStatus === getAssessmentStatuses.EVALUATED && isKSB === 'PF_CHATBOT_STUDY'">
                <v-btn @click.stop="goesToChatbotBeginning" id="btnGoToAssessmentBeginning" block color="primary" class="btn color-on-primary-text">{{text("api.chatbot.btn.finishAssessment")}}</v-btn>
            </div>
        </div>
    </div>
</template>

<!-- ################################################################## -->

<script>
    import {mapGetters} from 'vuex';

    export default {
        name: 'AnswerListEvaluationBtn',

        computed: {
            ...mapGetters({
                getCurrentAssessmentStatus: 'ChatBotStore/getCurrentAssessmentStatus',
                getAssessmentStatuses: 'ChatBotStore/getAssessmentStatuses',
                isKSB: 'TranslationStore/getAppTypeName',
                mustShowUrgentPopup: 'AssessmentAlertsStore/getMustShowUrgentPopup',
                getAppPropertyStudyAccess: 'TranslationStore/getAppPropertyStudyAccess'
            })
        },
        updated: function () {
            this.$nextTick(function () {
              if (this.getCurrentAssessmentStatus === this.getAssessmentStatuses.EVALUATED) {
                this.$emit('onAnswerListUpdated');
              }
            });
        },

        methods: {

            goToChatbotEvaluationPage () {

                // @TODO We should reset "chat conversation" (assessment) data in stores. We can do it here, but maybe it's better if we do it always when the user visits the chatbot page  (ChatBotPage component event: "beforeCreate").
                let promiseLoadEvaluationData = this.$store.dispatch("ChatBotStore/loadEvaluationData");
                promiseLoadEvaluationData.then(() => {
                    console.log("ASSESSMENT finished SAVED");
                    this.$router.push({name: 'PF_ChatBotEvaluationPage'});
                });
            },

            goesToChatbotBeginning() {
                let promiseLoadEvaluationData = this.$store.dispatch("ChatBotStore/loadEvaluationData");
                promiseLoadEvaluationData.then(() => {
                    console.log("CHATBOT_STUDY ASSESSMENT finished SAVED");
                    this.$router.push("/pathfinder/chatbot");
                    window.location.reload();
                });

            }

        }
    }
</script>

<!-- ################################################################## -->

<style lang="scss" scoped>


    .answer-item {
        display: inline-block;
        border: 1px solid #d3d5d9;
        border-radius: 20px;
        padding: 10px 20px;
        color: #a43a45;
        cursor: pointer;
        margin-right: 15px;
        margin-bottom: 10px;
    }


    .answer-list-evaluation-btn {
        width: 100%;
        .btn-eval {
            text-align: center !important;
        }
    }


    @media only screen and (max-width: 599px) {
        .evaluation-btn-container {
            margin: 0 16px;
        }
    }
    @media only screen and (min-width: 600px) {
        .evaluation-btn-container{
            margin: 0 24px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/pathfinder/components/chatbot/answer-list/AnswerListEvaluationBtn.vue